export const detectingMobile =
  !!navigator.platform &&
  /iPad|iPhone|iPod|Android|Linux/.test(navigator.platform);

export const detectingIos =
  process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
